import React from "react";


export const BasisGrid23 = ({children, style}) =>
    <div className="flex flex-row" style={style}>
        <div className={`basis-1/6`}></div>
        <div className={`basis-2/3`}>
            {children}
        </div>
        <div className={`basis-1/6`}></div>
    </div>


export const BasisGrid12 = ({children, style}) =>
    <div className="flex flex-row" style={style}>
        <div className={`basis-1/4`}></div>
        <div className={`basis-1/2`}>
            {children}
        </div>
        <div className={`basis-1/4`}></div>
    </div>